import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

interface RoleParameters {
  name: string;
  responsibility: string;
  permissions: (string | number)[];
}

export default {
  /**
   * Fetch the Accounts list with pagination
   */
  fetchRoles: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/roles`, { ...parameters });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchRolesFilterList: (): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/roles/list-filters`);
  },
  /**
   * Fetch the Accounts list with pagination
   */
  exportRoles: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/roles/export-roles`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchAllRoles: (): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/roles/role-names`, {});
  },
  /**
   * Fetch the permissions list
   */
  fetchAllPermissions: (): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/roles/permissions-list`, {});
  },
  /**
   * Create the role api call function
   * @param data
   * @returns
   */
  createRoles: (
    data: RoleParameters = {
      name: '',
      responsibility: '',
      permissions: [],
    },
  ): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.accountApiUrl}api/super-admin/v1/roles`, { ...parameters });
  },
  /**
   * Update the role api call function
   * @param data
   * @returns
   */
  editRoles: (
    id: string,
    data: RoleParameters = {
      name: '',
      responsibility: '',
      permissions: [],
    },
  ): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.accountApiUrl}api/super-admin/v1/roles/${id}`, { ...parameters });
  },
  /**
   * Update the role api call function
   * @param data
   * @returns
   */
  fetchRoleById: (id: string): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/roles/${id}`);
  },
  /**
   * Delete role api call function
   * @param id
   * @returns
   */
  deleteRoles: (id: string): Promise<any> => {
    return deleteRequest(`${config.accountApiUrl}api/super-admin/v1/roles/${id}`);
  },
};
